import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LayoutProvider } from './contexts/LayoutContext';
import './index.css';
import App from './App';
import { oidcConfig } from './auth/AuthConfig';

/**
 * Server-state cache (TanStack Query). Pages fetch through useQuery/useInfiniteQuery
 * instead of hand-written useState/useEffect loaders.
 * - staleTime 30s: navigating back to a page within 30s reuses cached data.
 * - refetchOnWindowFocus off: a batch with 28 record pages must not re-download on every tab switch.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <AuthProvider {...oidcConfig}>
    <QueryClientProvider client={queryClient}>
      <LayoutProvider>
        <App />
      </LayoutProvider>
    </QueryClientProvider>
  </AuthProvider>
);
